<template>
    <v-content class="gb">
        <v-container fluid>
            <v-row align="center" justify="center">
                <v-col cols="12" md="12">
                    <v-card :loading="status==='loading'" class="fill-width table_theme card-theme custom-container">
                        <v-row align="center" class="account-header">
                            <v-col>
                                <h2 class="medium-font billing-title">Account Info</h2>
                            </v-col>
                            <v-col style="text-align: end;">
                                <v-btn
                                    rounded
                                    depressed
                                    class="px-6 btn-blanco btn-blanco--a btn-billing"
                                    @click="show_CancelAccountModal"
                                >Cancel Account
                                </v-btn>
                            </v-col>
                        </v-row>
                        <v-row class="account-fields">
                            <v-col cols="6">
                                <v-text-field v-model="company_name" label="Company Name" name="company_name"
                                              id="company_name_billing" class="d-block"></v-text-field>
                            </v-col>
                            <v-col cols="6">
                                <v-text-field
                                    ref="addressField"
                                    v-model="message_address"
                                    :error-messages="addressError"
                                    label="Company Address"
                                    class="d-block"
                                    placeholder="Please type your address..."
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="account-fields" style="margin-top: -12px;">
                            <v-col cols="6">
                                <v-text-field v-model="phone_number" v-mask="mask" label="Username (Cell Phone Number)"
                                              id="phone_number_billing" class="d-block"></v-text-field>
                            </v-col>
                            <v-col cols="6">
                                <v-text-field v-model="email" label="Email" id="email_billing"
                                              class="d-block"></v-text-field>
                            </v-col>
                        </v-row>
                        <div class="text-center" style="margin: 20px 80px 30px;">
                            <v-btn
                                rounded
                                depressed
                                class="btn-azul"
                                :loading="status === 'loading'"
                                @click="saveChangesInfo"
                            >SAVE
                            </v-btn>
                        </div>

                        <div class="privacy-section">
                            <div class="privacy-row">
                                <div class="privacy-text">
                                    <h3 class="privacy-title">Data Export</h3>
                                    <p class="privacy-desc">Download a ZIP archive of everything Kiey stores about your account — profile, messages, files, contacts, calls, voicemails, and invoices. We'll email you a download link when it's ready (usually within a few minutes). The link expires after 7 days.</p>
                                </div>
                                <button type="button" class="privacy-btn" :disabled="exporting" @click="onExportClick">
                                    {{ exporting ? 'Preparing export…' : (exportRequested ? 'Export requested' : 'Export My Data') }}
                                </button>
                            </div>
                            <p v-if="exportError" class="privacy-error">{{ exportError }}</p>
                            <p v-if="exportRequested && !exportError" class="privacy-success">We're preparing your export. Check {{ user.email }} in a few minutes.</p>
                        </div>

                    </v-card>
                </v-col>
            </v-row>
            <update-modal :show="showUpdateModal" :hide="hideUpdateModal"/>
            <cancel-modal :show="showCancelAccountModal" :hide="hideCancelAccountModal"/>
            <unsaved-modal :show="showUnsavedModal" :hide="hideUnsavedModal" :onSave="saveAndNavigate"/>
        </v-container>
    </v-content>
</template>

<script>

    import updateModal from "./modals/update";
    import cancelAccountModal from "./modals/cancel";
    import unsavedModal from "@/views/owner/billing/modals/unsaved";
    import {mapState} from "vuex";
    import {mask} from "vue-the-mask";
    import {extractLocation} from "@/util/places";
    import {requestDataExport} from "@/util/data_export";

    export default {
        name: "Login",
        created() {
            this.$store.dispatch('Banner/show');

            this.message_address = this.user.address || '';
            this.originalValues = {
                company_name: this.company_name,
                message_address: this.user.address || '',
                phone_number: this.phone_number,
                email: this.user.email || '',
            };
        },
        mounted() {
            this.initAutocomplete();
        },
        beforeRouteLeave(to, from, next) {
            if (this.allowLeave) {
                next();
                return;
            }
            if (this.hasUnsavedChanges()) {
                this.pendingNext = next;
                this.showUnsavedModal = true;
            } else {
                next();
            }
        },
        directives: {
            mask,
        },
        computed: {
            ...mapState({
                status: state => state.Billing.status,
                user: state => state.Authenticate.user
            }),
            company_name: {
                get: function() {
                    return this.user.company_name
                },
                set: function(newValue) {
                    return newValue;
                }
            },
            address: {
                get: function() {
                    return this.user.address
                },
                set: function(newValue) {
                    return newValue;
                }
            },
            phone_number: {
                get: function() {
                    let number = this.user.phone_number.substring(2);
                    return number;
                },
                set: function(newValue) {
                    return newValue;
                }
            },
            email: {
                get: function() {
                    return this.user.email
                },
                set: function(newValue) {
                    return newValue;
                }
            }
        },
        data() {
            return {
                showUpdateModal: false,
                showCancelAccountModal: false,
                showUnsavedModal: false,
                pendingNext: null,
                allowLeave: false,
                originalValues: {},
                mask: "### - ### - ####",
                message_address: null,
                location: null,
                addressError: '',
                exporting: false,
                exportRequested: false,
                exportError: '',
            };
        },
        watch: {
            message_address(newVal) {
                this.addressError = '';
                if (this.location && this.location.address !== newVal) {
                    this.location = null;
                }
            },
        },
        components: {
            "update-modal": updateModal,
            "cancel-modal": cancelAccountModal,
            "unsaved-modal": unsavedModal,
        },
        methods: {
            show_CancelAccountModal() {
                this.showCancelAccountModal = true;
            },
            hideCancelAccountModal() {
                this.showCancelAccountModal = false;
            },
            hideUpdateModal() {
                this.showUpdateModal = false;
            },
            hideUnsavedModal() {
                this.showUnsavedModal = false;
                this.allowLeave = true;
                if (this.pendingNext) {
                    this.pendingNext();
                    this.pendingNext = null;
                }
            },
            saveAndNavigate() {
                this.showUnsavedModal = false;
                this.allowLeave = true;
                this.saveChangesInfo();
                if (this.pendingNext) {
                    this.pendingNext();
                    this.pendingNext = null;
                }
            },
            hasUnsavedChanges() {
                const strip = (val) => (val || '').replaceAll(' ', '').replaceAll('-', '');
                const el = (id) => {
                    const node = window.document.getElementById(id);
                    return node ? node.value : null;
                };
                const currentCompany = el("company_name_billing") || this.company_name;
                const currentEmail = el("email_billing") || this.email;
                const currentPhone = strip(el("phone_number_billing") || this.phone_number);
                const currentAddress = this.message_address || '';
                return currentCompany !== this.originalValues.company_name ||
                    currentAddress !== this.originalValues.message_address ||
                    currentPhone !== strip(this.originalValues.phone_number) ||
                    currentEmail !== this.originalValues.email;
            },
            saveChangesInfo() {
                let company_name = window.document.getElementById("company_name_billing").value;
                let company_name_current = this.user.company_name;
                let email = window.document.getElementById("email_billing").value;
                let new_phone_number = window.document.getElementById("phone_number_billing").value;
                let address = this.message_address || '';
                if (address !== this.originalValues.message_address && !this.location) {
                    this.addressError = 'Please pick your address from the dropdown suggestions.';
                    return;
                }
                this.addressError = '';
                let phone_raw = new_phone_number;
                new_phone_number = new_phone_number.replaceAll(' ', '').replaceAll('-', '');
                this.originalValues = {
                    company_name: company_name,
                    message_address: address,
                    phone_number: phone_raw,
                    email: email,
                };
                this.$store.dispatch('Billing/update_info_company_from_vendor',
                    {
                        company_name: company_name,
                        company_name_current: company_name_current,
                        address: address,
                        location: this.location,
                        new_phone_number: new_phone_number,
                        email: email,
                        owner_id: this.user.owner_id,
                        tenant_id: this.user.tenant_current_logged,
                        user: this.user
                    }
                ).then(() => {
                    this.showUpdateModal = true;
                }).catch((error) => {
                    console.error('Save failed:', error);
                    this.$store.commit('Billing/success');
                });
            },
            async onExportClick() {
                if (this.exporting || this.exportRequested) return;
                this.exporting = true;
                this.exportError = '';
                try {
                    await requestDataExport();
                    this.exportRequested = true;
                } catch (err) {
                    console.error('Data export request failed:', err);
                    this.exportError = "We couldn't start your export. Please try again or contact support@kiey.com.";
                } finally {
                    this.exporting = false;
                }
            },
            async initAutocomplete() {
                const self = this;
                await this.$gmapApiPromiseLazy();
                await this.$nextTick();
                const input = self.$refs.addressField.$el.querySelector('input');
                if (!input) return;
                const autocomplete = new window.google.maps.places.Autocomplete(input, {
                    types: ['address'],
                    componentRestrictions: { country: ['us', 'ca'] },
                });
                autocomplete.addListener('place_changed', () => {
                    const place = autocomplete.getPlace();
                    if (place && place.formatted_address) {
                        self.message_address = place.formatted_address;
                        self.location = extractLocation(place);
                    }
                });
            },
        }
    };
</script>

<style lang="scss">
    .custom-container {
        max-width: 1222px !important;
        min-height: auto;
        top: 40px;
        margin-bottom: 50px !important;
        padding: 30px 50px;
    }

    .sub_link_header {
        color: #717e91 !important;
    }

    .btn-billing {
        font-size: 13px !important;
        font-weight: 400 !important;
        width: 148px !important;
        height: 32px !important;
        letter-spacing: normal;
        text-transform: capitalize;
        position: relative;
        border-radius: 24px;
        border: 2px solid #29abe2;
        &.btn-blanco--a {
            span {
                color: #2bace2 !important;
            }
        }
    }

    .billing-title {
        color: #041332;
        font-size: 30px;
        font-weight: 500;
        line-height: 34px;
        letter-spacing: normal;
        padding-bottom: 7px;
    }

    .account-header {
        margin: 0 80px;
        padding: 0;
    }

    .account-fields {
        margin: 12px 68px;

        .v-text-field .v-label {
            top: 2px;
        }

        .v-text-field input {
            margin-top: 8px;
            padding-bottom: 6px;
        }
    }

    .privacy-section {
        margin: 8px 80px 30px;
        padding: 24px 0 8px;
        border-top: 1px solid #e8ebef;
    }
    .privacy-row {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        gap: 24px;
    }
    .privacy-text { flex: 1; min-width: 0; }
    .privacy-title {
        color: #041332;
        font-size: 18px;
        font-weight: 500;
        margin: 0 0 6px;
    }
    .privacy-desc {
        color: #5e6b85;
        font-size: 13px;
        line-height: 19px;
        margin: 0;
        max-width: 540px;
    }
    .privacy-btn {
        flex: 0 0 auto;
        background: #ffffff;
        border: 1px solid #061d47;
        color: #061d47;
        font-size: 13px;
        font-weight: 500;
        padding: 8px 18px;
        border-radius: 24px;
        cursor: pointer;
        line-height: 1;
        transition: background-color 0.15s ease, color 0.15s ease;
    }
    .privacy-btn:hover:not(:disabled) {
        background: #061d47;
        color: #ffffff;
    }
    .privacy-btn:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
    .privacy-error {
        color: #c0392b;
        font-size: 13px;
        margin: 12px 0 0;
    }
    .privacy-success {
        color: #2e7d32;
        font-size: 13px;
        margin: 12px 0 0;
    }
    @media (max-width: 768px) {
        .privacy-section { margin: 8px 16px 24px; }
        .privacy-row { flex-direction: column; }
        .privacy-btn { width: 100%; }
    }
</style>
